// extracted by mini-css-extract-plugin
module.exports = {"fullWidthBackground":"FullWidthBackground_fullWidthBackground__X3JNr","hasNoBackground":"FullWidthBackground_hasNoBackground__2xamG"};